(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ra-collection-card-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ra-card-add')) {
    const BUSY_TIMEOUT = 15000;

    class RaCardAdd extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('[data-ra-card-trigger]');
        this.dialog = this.querySelector('dialog');
        this.status = this.closest('.ra-card-buttons')?.querySelector('[data-ra-card-status]');
        this.trigger?.addEventListener('click', this.onTrigger);
        /* iOS Safari shows :active (the instant pressed look) only where a touch listener exists */
        this.addEventListener('touchstart', () => {}, { passive: true });
        if (!this.dialog) return;
        this.uniqueIds();
        this.form = this.dialog.querySelector('form');
        this.error = this.dialog.querySelector('[data-ra-card-error]');
        this.submit = this.form.querySelector('[type="submit"]');
        this.form.addEventListener('submit', this.onSubmit);
        this.dialog.addEventListener('click', this.onDialogClick);
        this.dialog.addEventListener('close', this.onClose);
      }

      /*
        A product list can print the same card twice (Horizon's grid and its phone carousel), so the
        picker's ids repeat and this copy's aria-controls / aria-labelledby would name the other copy.
        A repeated copy gets its own ids.
      */
      uniqueIds() {
        if (document.getElementById(this.dialog.id) === this.dialog) return;
        const suffix = `-${(RaCardAdd.copies = (RaCardAdd.copies || 0) + 1)}`;
        const renamed = new Map();
        this.querySelectorAll('[id]').forEach((el) => {
          renamed.set(el.id, el.id + suffix);
          el.id += suffix;
        });
        this.querySelectorAll('[aria-controls], [aria-labelledby]').forEach((el) => {
          for (const attr of ['aria-controls', 'aria-labelledby']) {
            const value = el.getAttribute(attr);
            if (value) el.setAttribute(attr, value.split(' ').map((id) => renamed.get(id) || id).join(' '));
          }
        });
      }

      disconnectedCallback() {
        this.trigger?.removeEventListener('click', this.onTrigger);
        if (this.dialog?.open) document.documentElement.classList.remove('ra-card-picker-open');
      }

      onTrigger = (event) => {
        event.preventDefault();
        if (this.trigger.getAttribute('aria-busy') === 'true') return;
        if (this.dialog) {
          if (this.error.firstChild) this.error.textContent = '';
          this.dialog.showModal();
          document.documentElement.classList.add('ra-card-picker-open');
          /* Focus moves to the first option without picking it: a radio is only checked by a tap or Space. */
          (this.dialog.querySelector('input:checked') || this.dialog.querySelector('input:not(:disabled)'))?.focus();
          return;
        }
        this.add(this.trigger.dataset.variantId, this.trigger, (message) => {
          if (this.status) this.status.textContent = message;
        });
      };

      /* Clicks inside the dialog must not reach the card, which navigates on a plain click. */
      onDialogClick = (event) => {
        event.stopPropagation();
        if (event.target.closest('[data-ra-card-close]')) {
          this.dialog.close();
          return;
        }
        if (event.target === this.dialog) {
          const box = this.dialog.getBoundingClientRect();
          const inside =
            event.clientX >= box.left && event.clientX <= box.right && event.clientY >= box.top && event.clientY <= box.bottom;
          if (!inside) this.dialog.close();
        }
      };

      onClose = () => {
        document.documentElement.classList.remove('ra-card-picker-open');
        this.trigger?.focus();
      };

      onSubmit = (event) => {
        event.preventDefault();
        const chosen = this.form.querySelector('input[name="id"]:checked');
        if (!chosen) {
          this.error.textContent = `${this.dialog.querySelector('legend')?.textContent.trim() || 'Choose an option'} first.`;
          return;
        }
        this.add(chosen.value, this.submit, (message) => {
          this.error.textContent = message;
        }).then((ok) => {
          if (ok) this.dialog.close();
        });
      };

      async add(id, button, showError) {
        if (button.getAttribute('aria-busy') === 'true') return false;
        const label = button.querySelector('[data-ra-card-label]');
        const original = label.textContent;
        showError('');
        button.setAttribute('aria-busy', 'true');
        button.setAttribute('aria-disabled', 'true');
        label.textContent = 'Adding…';

        try {
          /* Review M2 (2026-10-18): busy until the add settles (assets/ra-pdp-cart.js time-limits every request, so
             it does), with "Checking…" after BUSY_TIMEOUT. Only an add nobody heard (detail.accepted unset: nothing
             was sent) is given up then. */
          let timer = 0;
          await new Promise((resolve, reject) => {
            const detail = {
              items: [{ id: Number(id), quantity: 1 }],
              source: 'ra-card',
              resolve: (cart) => {
                clearTimeout(timer);
                resolve(cart);
              },
              reject: (error) => {
                clearTimeout(timer);
                reject(error);
              },
            };
            this.dispatchEvent(new CustomEvent('ra:cart-add', { bubbles: true, detail }));
            timer = setTimeout(() => {
              if (!detail.accepted) reject(new Error('timeout'));
              else label.textContent = 'Checking…';
            }, BUSY_TIMEOUT);
          });
          label.textContent = original;
          return true;
        } catch (error) {
          label.textContent = original;
          /*
            Pass 4 follow-up A5 (2026-10-19): the deal boxes' words (assets/ra-ls1.js, ra-reel-buybox.js, ra-nb2-min.js),
            never "try again" when the add may have landed (.uncertain), nothing was sent (.offline), or Shopify added
            only what was in stock (422; assets/ra-pdp-cart.js hands over the cart as it is now in error.cart). Kept
            inside add() so the add harness (.debug/review-fixes-1018/add-harness.cjs) still runs it as one slice.
          */
          const size =
            button !== this.trigger &&
            this.form?.querySelector('input[name="id"]:checked')?.closest('label')?.querySelector('.ra-card-picker__name')?.textContent.trim();
          const name = size || this.dataset.title;
          const whyNot = () => {
            if (!error) return '';
            if (error.offline) return error.message;
            if (error.uncertain) return `We could not confirm ${this.dataset.title} was added. Check your cart before adding again.`;
            if (error.status !== 422) return '';
            let n = 0;
            for (const line of error.cart?.items || []) if (Number(line.variant_id) === Number(id)) n += Number(line.quantity) || 0;
            if (n > 0) return `Only ${n} of ${name} in stock, so your cart now has ${n}.`;
            if (error.cart) return `${name} is out of stock.`;
            return `${String(error.description || '').trim()} Check your cart before adding again.`.trim();
          };
          const why = whyNot();
          if (why) {
            showError(why);
            return false;
          }
          /* a plain failure: nothing was added, so trying again is safe */
          const reason = error?.message && error.message !== 'timeout' ? ` ${error.message}` : ' Please try again.';
          showError(`Could not add ${this.dataset.title} to your cart.${reason}`);
          return false;
        } finally {
          button.removeAttribute('aria-busy');
          button.removeAttribute('aria-disabled');
        }
      }
    }

    customElements.define('ra-card-add', RaCardAdd);
  }
  } catch(e) { console.error(e); }
})();

})();
